import React, { ComponentType } from 'react'
import { View } from 'src/ui/basic/View'
import { css } from 'src/ui/style/css'
import { Theme } from 'src/ui/style/Theme'
import { DesktopNavigation } from 'src/layout/header/navigation/DesktopNavigation'
import { MobileNavigation } from 'src/layout/header/navigation/MobileNavigation'
import { Link } from 'react-router-dom'
import { centeredContent } from 'src/ui/style/mixins/layout'
import { mediaMaxWidth } from 'src/ui/style/mixins/helpers'
import { Logo } from 'src/brand/Logo'
import { sticky } from 'src/ui/style/mixins/other'
import { useSearchParams } from '../../app/useSearchParams'
import { isAndroidNativeApp, isIosNativeApp } from '../../geo/locationService'
import { useLocation } from 'react-router'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const routes = require('src/routing/routes').default

const LogoComponent: ComponentType = () => {
    const limitedView = useSearchParams().get('limitedView') === 'true'

    if (limitedView) {
        return (
            <View
                css={css`
                    height: 100%;
                    margin-right: auto;
                `}
            >
                <Logo />
            </View>
        )
    }

    return (
        <Link
            to={
                isIosNativeApp() || isAndroidNativeApp()
                    ? routes.landingWebview.path
                    : '/'
            }
            onClick={() => {
                if (isIosNativeApp() || isAndroidNativeApp()) {
                    sessionStorage.removeItem('setRedirect')
                    localStorage.removeItem('setRedirectPersistent')
                }
            }}
            css={css`
                height: 100%;
                margin-right: auto;
            `}
        >
            <Logo />
        </Link>
    )
}

// For calculation of positions related components
export const headerDimension = {
    desktopHeight: '5em',
    mobileHeight: '4em',
    approximateFixedHeight: 80,
    zIndex: 1001
}
export const Header: ComponentType = () => {
    const location = useLocation()
    const isNativeApp =
        (isIosNativeApp() || isAndroidNativeApp()) &&
        location.pathname === routes.landingWebview.path

    if (isNativeApp) return null

    return (
        <View
            horizontal
            css={(th: Theme) => [
                sticky(headerDimension.zIndex),
                css`
                    padding: ${th.spacing.md};
                    top: 0;
                    background: ${th.colors.white};
                    align-items: stretch;
                    height: ${headerDimension.desktopHeight};
                    box-shadow: ${th.boxShadow.bottomOnly};
                    ${mediaMaxWidth(th.screens.md)} {
                        height: ${headerDimension.mobileHeight};
                    }
                `
            ]}
        >
            <View
                horizontal
                css={(th: Theme) => [
                    centeredContent()(th),
                    css`
                        // Spread children to sides
                        justify-content: space-between;
                    `
                ]}
            >
                <LogoComponent />
                <View
                    css={(th: Theme) => css`
                        ${mediaMaxWidth(th.screens.md)} {
                            display: none;
                        }
                    `}
                >
                    <DesktopNavigation />
                </View>
                <View
                    css={(th: Theme) => css`
                        display: none;
                        ${mediaMaxWidth(th.screens.md)} {
                            display: flex;
                        }
                    `}
                >
                    <MobileNavigation />
                </View>
            </View>
        </View>
    )
}
